import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "loan-details-tile" }
const _hoisted_2 = { class: "application-status-tile" }
const _hoisted_3 = { class: "todo-list-tile" }
const _hoisted_4 = { class: "file-upload-tile" }

import { computed } from "vue";
import { useStore } from "vuex";
import ApplicationInfo from "@/components/ApplicationInfo.vue";
import ApplicationStatus from "@/components/ApplicationStatus.vue";
import ApplicationChecklist from "@/components/ApplicationChecklist.vue";
import ApplicationFileUpload from "@/components/ApplicationFileUpload.vue";
import ApplicationReapply from "@/components/shared/ApplicationReapply.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ApplicationPEL',
  props: {
  showApplicationInfoTile: { type: Boolean, required: true },
  showApplicationFileUpload: { type: Boolean, required: true },
  showTodoListTile: { type: Boolean, required: true },
},
  emits: ["stepComplete", "hydrateStore", "viewCertificationUpdates"],
  setup(__props, { emit: __emit }) {

const store = useStore();

const emit = __emit;

const props = __props;

const appData = computed(() => store.state?.appData);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sc-container-grid", {
      'loan-details-tile-hidden': !__props.showApplicationInfoTile,
      'todo-list-tile-hidden': !__props.showTodoListTile,
      'file-upload-tile-hidden': !__props.showApplicationFileUpload,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (__props.showApplicationInfoTile)
        ? (_openBlock(), _createBlock(ApplicationInfo, {
            key: 0,
            application: appData.value.application,
            applicant: appData.value.currentApplicant,
            onComplete: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('stepComplete'))),
            onHydrateStore: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('hydrateStore')))
          }, null, 8, ["application", "applicant"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ApplicationStatus, {
        onViewCertificationUpdates: _cache[2] || (_cache[2] = ($event: any) => (emit('viewCertificationUpdates')))
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      (__props.showTodoListTile)
        ? (_openBlock(), _createBlock(ApplicationChecklist, {
            key: 0,
            application: appData.value.application,
            applicant: appData.value.currentApplicant,
            onHydrateStore: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('hydrateStore')))
          }, null, 8, ["application", "applicant"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (__props.showApplicationFileUpload)
        ? (_openBlock(), _createBlock(ApplicationFileUpload, {
            key: 0,
            application: appData.value.application,
            applicant: appData.value.currentApplicant
          }, null, 8, ["application", "applicant"]))
        : _createCommentVNode("", true),
      _createVNode(ApplicationReapply)
    ])
  ], 2))
}
}

})